/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlMatterLayoutFieldsFragment = {
  __typename: "MatterLayout";
  id: string;
  providerId: string;
  name: string;
  parentId?: string | null;
  parentName?: string | null;
  parentProviderId?: string | null;
  displayName?: string | null;
};

export type GqlMatterLayoutFieldsQueryVariables = Types.Exact<{
  matterLayoutId: Types.Scalars["String"]["input"];
  providerId: Types.Scalars["String"]["input"];
}>;

export type GqlMatterLayoutFieldsQuery = {
  __typename: "Query";
  matterLayoutFields: Array<{
    __typename: "MatterField";
    name: string;
    type: string;
    possibleValues?: Array<string> | null;
    dataSourceMapping?: string | null;
    displayName?: string | null;
    details?: string | null;
    allowedRepeatable?: boolean | null;
    hint?: string | null;
  }>;
};

export const MatterLayoutFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "matterLayoutFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatterLayout" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "providerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "parentName" } },
          { kind: "Field", name: { kind: "Name", value: "parentProviderId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlMatterLayoutFieldsFragment, unknown>;
export const MatterLayoutFieldsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "matterLayoutFields" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "matterLayoutId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "providerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "matterLayoutFields" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "matterLayoutId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "matterLayoutId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "providerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "providerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "possibleValues" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dataSourceMapping" },
                },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedRepeatable" },
                },
                { kind: "Field", name: { kind: "Name", value: "hint" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlMatterLayoutFieldsQuery,
  GqlMatterLayoutFieldsQueryVariables
>;
